"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentDefinition = void 0;
const helpers_1 = require("@wix/services-manager/helpers");
exports.EnvironmentDefinition = (0, helpers_1.defineService)('viewer-core/environment');
//# sourceMappingURL=environmentDefinition.js.map